import * as React from 'react';
import classnames from 'classnames';
import { Card } from '@grandvisionhq/common';
import { Divider } from '@grandvisionhq/elements';
import { Toggletip } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { RemoveVoucherCodeContainer } from '../RemoveVoucherCode/RemoveVoucherCodeContainer.js';

const AppliedDiscounts = ({ appliedCartDiscounts , isReadOnly  })=>{
    const { getLabel  } = useIntl();
    if (!(appliedCartDiscounts === null || appliedCartDiscounts === void 0 ? void 0 : appliedCartDiscounts.length)) return null;
    return /*#__PURE__*/ React.createElement("ul", {
        className: "voucher-codes__list"
    }, appliedCartDiscounts.map((discount, index)=>/*#__PURE__*/ React.createElement("li", {
            key: discount.code,
            className: "voucher-codes__list-item"
        }, index > 0 ? /*#__PURE__*/ React.createElement(Divider, {
            className: classnames('voucher-codes__divider', {
                'voucher-codes__divider--read-only': isReadOnly
            }),
            theme: "light"
        }) : isReadOnly ? null : /*#__PURE__*/ React.createElement(Divider, {
            theme: "light"
        }), /*#__PURE__*/ React.createElement(Card.Section, {
            className: classnames('voucher-codes__entry', {
                'voucher-codes__entry--inactive': discount.type === 'UNAPPLIED_DISCOUNT_CODE'
            }),
            spacing: "none"
        }, /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Text, {
            className: "voucher-codes__entry-header"
        }, discount.title, discount.code && ` (${discount.code})`), /*#__PURE__*/ React.createElement(Card.Text, null, discount.description), discount.type === 'APPLIED_CART_DISCOUNT' ? /*#__PURE__*/ React.createElement(Card.Text, {
            className: "voucher-codes__entry-message voucher-codes__entry-message--success"
        }, getLabel('cart.discounts.automaticallyApplied')) : null, discount.type === 'UNAPPLIED_DISCOUNT_CODE' ? /*#__PURE__*/ React.createElement(Card.Section, {
            className: "voucher-codes__entry-message voucher-codes__entry-message--failed"
        }, /*#__PURE__*/ React.createElement(Card.Text, null, getLabel('cart.discounts.notApplied')), /*#__PURE__*/ React.createElement(Toggletip, {
            id: discount.title,
            message: getLabel('cart.discounts.notAppliedExplanation'),
            placement: "bottom",
            // TODO: add actual aria label
            ariaLabel: getLabel('cart.discounts.notAppliedExplanation')
        })) : null), !isReadOnly ? /*#__PURE__*/ React.createElement(Card.ButtonLayout, {
            className: "voucher-codes__entry-button-container"
        }, discount.code ? /*#__PURE__*/ React.createElement(RemoveVoucherCodeContainer, {
            voucherCode: discount.code
        }) : null) : null))
    ));
};

export { AppliedDiscounts };
//# sourceMappingURL=AppliedDiscounts.js.map
